export enum SiteType {
  Normal = 1,
  System = 2,
  Template = 3,
  IncomingProcessing = 4,
  Program = 5,
}
